/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unlocked_SuccessfulInputs */

const en_unlocked_successful = /** @type {(inputs: Unlocked_SuccessfulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You've unlocked the <b>Planet Guardian</b>!`)
};

const ar_unlocked_successful = /** @type {(inputs: Unlocked_SuccessfulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لقد فتحت <b>حارس الكوكب</b>!`)
};

const de_unlocked_successful = /** @type {(inputs: Unlocked_SuccessfulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast den <b>Planet Guardian</b> freigeschaltet!`)
};

const es_unlocked_successful = /** @type {(inputs: Unlocked_SuccessfulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Has desbloqueado al <b>Guardián del planeta</b>!`)
};

const fr_unlocked_successful = /** @type {(inputs: Unlocked_SuccessfulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous avez débloqué le <b>Gardien de la Planète</b> !`)
};

const it_unlocked_successful = /** @type {(inputs: Unlocked_SuccessfulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai sbloccato il <b>Guardiano del pianeta</b>!`)
};

const ja_unlocked_successful = /** @type {(inputs: Unlocked_SuccessfulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<b>プラネット・ガーディアン</b>をアンロックしました！`)
};

const ko_unlocked_successful = /** @type {(inputs: Unlocked_SuccessfulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<b>행성 수호자</b>를 잠금 해제했습니다!`)
};

const pt_br_unlocked_successful = /** @type {(inputs: Unlocked_SuccessfulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você desbloqueou a <b>Guardiã do Planeta</b>!`)
};

const ru_unlocked_successful = /** @type {(inputs: Unlocked_SuccessfulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы разблокировали <b>Хранителя планеты</b>!`)
};

const th_unlocked_successful = /** @type {(inputs: Unlocked_SuccessfulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณได้ปลดล็อก <b>ผู้พิทักษ์โลก</b> แล้ว!`)
};

const tr_unlocked_successful = /** @type {(inputs: Unlocked_SuccessfulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<b>Gezegen Koruyucusu</b>'nun kilidini açtın!`)
};

const zh_cn_unlocked_successful = /** @type {(inputs: Unlocked_SuccessfulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你成功解锁了 <b>守星木</b>！`)
};

const zh_tw_unlocked_successful = /** @type {(inputs: Unlocked_SuccessfulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你成功解鎖了 <b>守星木</b>！`)
};

/**
* | output |
* | --- |
* | "You've unlocked the <b>Planet Guardian</b>!" |
*
* @param {Unlocked_SuccessfulInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const unlocked_successful = /** @type {((inputs?: Unlocked_SuccessfulInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unlocked_SuccessfulInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unlocked_successful(inputs)
	if (locale === "ar") return ar_unlocked_successful(inputs)
	if (locale === "de") return de_unlocked_successful(inputs)
	if (locale === "es") return es_unlocked_successful(inputs)
	if (locale === "fr") return fr_unlocked_successful(inputs)
	if (locale === "it") return it_unlocked_successful(inputs)
	if (locale === "ja") return ja_unlocked_successful(inputs)
	if (locale === "ko") return ko_unlocked_successful(inputs)
	if (locale === "pt_br") return pt_br_unlocked_successful(inputs)
	if (locale === "ru") return ru_unlocked_successful(inputs)
	if (locale === "th") return th_unlocked_successful(inputs)
	if (locale === "tr") return tr_unlocked_successful(inputs)
	if (locale === "zh_cn") return zh_cn_unlocked_successful(inputs)
	return zh_tw_unlocked_successful(inputs)
});